<template>
  <div>
  <div class="typed-on-paper-a4">
    <div class="text-align-center">
      <h1>CAMPAIGN RULES</h1>
    </div>
    <br>
    <div class="text-align-left">
      <p>These rules apply as a working / interim proposal, until such time as a formal decision will be made about them.</p>
      <p><b>One life only</b> – being killed, bailing out or otherwise breaking the aircraft terminates a pilot’s participation in the mission.  Pilots are not to despawn / leave the server until their aircraft or parachutist (if bailing out) comes to ground. Once this has occurred, pilots should leave the server as soon as possible.</p>
      <p>No re-flies are allowed unless specifically briefed to use the available re-arming / refuelling stations. </p>
      <p><b>There is no repair facility or replacement aircraft</b> –exception: pilots / aircraft suffering mishaps on initial sortie (collisions, overheating etc, but not shoot downs) up to and including climb-out may RTB and re-spawn. Wounded pilots or pilots with damaged aircraft should seek their OCs approval before attempting a second sortie after re-arming / refuelling.</p>
      <p><b>ROE as per the Campaign Briefing.</b>  All airfields are ‘Vulnerable’. IAW the ROE, pilots may respawn if attacked / destroyed on the ground on initial spawn in. Pilots and aircraft attacked while refuelling mid-mission are vulnerable and may be destroyed even when on the ground. </p>
      <p><b>Units may take off as soon as they are ready after their connection time</b> – this is a particular imperative for those with shorter time slots as any delay eats into the flying time available. Conversely, those with longer missions may stagger take offs so the whole unit does not need to refuel at the same time. The ‘Land NLT’ time is the time by which all pilots of the unit must be down and out of the server and pilots are to plan accordingly.</p>
      <p><b>In the event of a game crash, a player may re-start the game and rejoin</b> but only if this occurred before any engagement with the enemy (i.e. their participation has not already impacted on players on the other side and potential outcomes).  If in doubt, refer to unit OC.</p>
      <p>The rules and procedures for secondary / volunteer sorties will published in due course. </p>
      <p>Within the framework of the above rules, pilots should strive to complete the task(s) assigned to them in the briefing. Any departure from the briefed instructions should be explained / justified to that side’s senior leadership and the mission planners as soon as possible after the mission.</p>
      <p>All pilots are to submit an After Action Report (AAR), ideally as soon as possible but no later than 4 days after completing the mission (ie the following Thursday).  The best AARs are written from memory, no matter how incomplete or mistaken.  Pilots should avoid using and referring to recordings in writing their AARs.  OCs are encouraged to include an overview of their unit’s activity / performance to help build a narrative for the wider mission for both mission planners and general readers. </p>
      <p>Claims should be submitted in the AARs IAW with procedures of the pilot’s character nationality.   If in doubt, pilots should refer to their OC for guidance.</p>
      <p>(NB: The detailed claiming rules for each nationality will be published in due course)   </p>
    </div>
  </div>
  </div>
</template>

<script>

  export default {
    name: "CampaignRules"
  }
</script>

<style scoped>

.iconImage {
  max-height: 40px;
}

.navbar-tabs {
  min-height: 0px;
  width: calc(100% - 0px); /* Whished widht in % minus 2x border size */
  padding: 20px;
  padding-bottom: 15px;
  font-family: "Remingtoned Type";
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  background-image: url("/frontend/src/assets/images/ftcpaper.png");
  /*background: linear-gradient(90deg, #ebebe9 1px, #ebe6e6 1px, #efeeec 1px, #e7e6e4 1px, #eae6e5 1px);*/
  box-shadow: 0px -5px 15px rgba(10,10,10,0.3);
  color: #1b1b1b;
}

.navigationList li {
  display: table-cell;
  font-size: 125%;
  text-align: center;
}

.navigationList li a {
  padding: 0px 40px;
  text-decoration: none;
  font-weight: bold;
  color: #1b1b1b;
}

.navigationList li a:hover{
  color: #1b1b1b;
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  border-radius: 25px;
}

</style>



// WEBPACK FOOTER //
// src/components/info/CampaignRules.vue